import React from "react";

export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 9.20694 2.88876 10.3231 3.5479 11.23C4.88506 10.5499 6.3984 10.1667 8 10.1667C9.6016 10.1667 11.1149 10.5499 12.4521 11.23C13.1112 10.3231 13.5 9.20694 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM12.9736 12.1851C13.9261 11.0544 14.5 9.59421 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 9.59422 2.07393 11.0544 3.02644 12.1852C3.03036 12.19 3.03435 12.1947 3.03842 12.1993C4.23073 13.6067 6.01104 14.5 8 14.5C9.98895 14.5 11.7693 13.6067 12.9616 12.1994C12.9656 12.1947 12.9697 12.19 12.9736 12.1851ZM11.7668 12.0076C10.6247 11.4683 9.34812 11.1667 8 11.1667C6.65189 11.1667 5.37533 11.4683 4.23318 12.0076C5.21736 12.933 6.54247 13.5 8 13.5C9.45753 13.5 10.7826 12.933 11.7668 12.0076ZM8 5.16667C7.17157 5.16667 6.5 5.83824 6.5 6.66667C6.5 7.49509 7.17157 8.16667 8 8.16667C8.82843 8.16667 9.5 7.49509 9.5 6.66667C9.5 5.83824 8.82843 5.16667 8 5.16667ZM5.5 6.66667C5.5 5.28595 6.61929 4.16667 8 4.16667C9.38071 4.16667 10.5 5.28595 10.5 6.66667C10.5 8.04738 9.38071 9.16667 8 9.16667C6.61929 9.16667 5.5 8.04738 5.5 6.66667Z"
      fill="#141414"
    />
  </svg>
);
